import { createContext } from 'react';

export const Amministratore = createContext(1);